import React, { Component } from 'react';
import './inviteUser.scss';
import Footer from '../../containers/Footer/footer';
import BasicHeader from '../../containers/basicHeader/basicHeader';
import editUserStatus from '../../services/user/editUserStatus';
import getUserByEmail from '../../services/user/getUserByEmail';
// import { Redirect } from 'react-router-dom';
import qs from 'qs';
import atob from 'atob';
import withRouter from '../../containers/withRouter';

class InviteUser extends React.Component {
    
    constructor(){
        super();

        this.state = {
            userEmail: '',
            tokencheck:true
        }
    }

    componentDidMount() {
        const query = new URLSearchParams(this.props.location.search);
        const email = query.get('email')

        try {
            let decryptEmail = atob(email);
            let data = {
                email: decryptEmail
            }
    
            this.state.userEmail = decryptEmail;
            this.getUser(decryptEmail)
        } catch(e) {
            document.querySelector('.wrongEmail').classList.remove('hidden');
        }
    }

    editUserStatusByEmail = async (data) => {
        let values = await editUserStatus(data);
        // if operation is successful
        if(values.data.status.code == 10200){
            document.querySelector('.successfulUpdate').classList.remove('hidden');
        }
        // if operations fails
        else{
            const response = JSON.parse(values.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }

            document.querySelector('.failedUpdate').classList.remove('hidden');
        }
    }

    getUser = async (email) => {
        let values = await getUserByEmail(email);

        //check if user exists
        if(values[0].count){
            //check if user status is already 1
            if(values[0].users[0].status == 1){
                document.querySelector('.alreadyActivated').classList.remove('hidden');
            }
            else if(values[0].users[0].status == 0){
                let data = {
                    email: this.state.userEmail
                }
                this.editUserStatusByEmail(data);
            }
        }
        else{
            const response = JSON.parse(result.request.response);
            const code = response?.status?.code;
            if (code == 10411 || code == 10412 || code == 10416 || code == 10417) {
                this.setState({ tokencheck: false });
                cookie.delete_cookie(process.env.REACT_APP_COOKIE_NAME);
                cookie.delete_cookie('loginProfileInfo');
                AuthObject.isAuthenticated = false;
            }

            document.querySelector('.wrongEmail').classList.remove('hidden');
        }
    }

    render() {
        if (!this.state.tokencheck) {
            return <Navigate to={'/'} />
        }

        return (
            <div>
                <BasicHeader />
                    <section className="bodyWrapper">
                        <div className="box successfulUpdate hidden">
                            Your account has been successfully activated
                        </div>
                        <div className="box failedUpdate hidden">
                            Your account could not be activated. Please try again.
                        </div>
                        <div className="box alreadyActivated hidden">
                            Your account is already activated.
                        </div>
                        <div className="box wrongEmail hidden">
                            Wrong email id.
                        </div>
                    </section>
                <Footer />
            </div>
        );
    }

}

export default withRouter(InviteUser);